
import { useI18n } from "vue-i18n";
import { Locale } from "vant";
import { reactive } from "vue";
import { getLanguageFlag, saveLanguageFlag } from "@/utils/localStorageUtils";

export const ZH_CN = 'zh-CN'
export const ZH_TW = 'zh-TW'
export const EN_US = 'en-US'
export const MS_MY = 'ms-MY'

// 语言选项元数据：label 为各语言本名（无论当前界面语言都固定显示），short 用于紧凑按钮
export const LANGUAGE_OPTIONS = [
  { value: ZH_CN, label: '简体中文', short: '简' },
  { value: ZH_TW, label: '繁體中文', short: '繁' },
  { value: EN_US, label: 'English', short: 'EN' },
  { value: MS_MY, label: 'Bahasa Melayu', short: 'BM' },
];

export const getLanguageShort = (lang) => {
  const found = LANGUAGE_OPTIONS.find((item) => item.value === lang);
  return found ? found.short : 'EN';
};
// let CURRENT_LANGUAGE = ZN

export const useNewLanguageEffect = () => {
    const { locale, getLocaleMessage } = useI18n();
    const onSystemChangeLanguage = (value) => {
        // 切换一下语言
        locale.value = value;
        Locale.use(locale.value, getLocaleMessage(locale.value).van);
        saveLanguageFlag(value);
    };
    return { onSystemChangeLanguage }
}

export const getCurrentLanguage = () => {
    return getLanguageFlag();
}


export const IS_CN = () => {
    return getLanguageFlag() === ZH_CN;
}

export const IS_EN = () => {
    return getLanguageFlag() === EN_US;
}







export const useLanguageEffect = () => {
    const { locale, t } = useI18n();
    const switchLanguage = lang => {
        locale.value = lang; // 更新 vue-i18n 的语言
        Locale.use(lang, t(lang).van); // 同步更新 Vant 的语言
    }
    const switchEnLanguage = () => {
        console.log('enen')
        switchLanguage(EN_US);
    }
    const switchCnLanguage = () => {
        switchLanguage(ZH_CN);
    }
    return { switchEnLanguage, switchCnLanguage }
}

